// extracted by mini-css-extract-plugin
export default {"container":"thematic-break-module__container--HG7ab","thematicBreak":"thematic-break-module__thematicBreak--ck8zK"};